---
en:
  admin:
    power_plants:
      delete_data:
        confirm_hint: This cannot be undone. Type the plant name "{name}" to confirm.
        confirm_label: Plant name
        counts:
          downtime_days: Downtime days
          downtime_events: Downtime events
          downtime_periods: Downtime hours
          orphaned_downtime_events: Downtime events left incomplete
          production_days: Production days
          production_periods: Production periods
          production_quarters: Production quarters
          revenue_periods: Revenue periods
          verified_downtime_events: Verified downtime events
        delete: Delete data
        deleted_body: "{count} rows removed."
        deleted_title: Production data deleted
        deleting: Deleting. Do not close this dialog until it finishes.
        description: Permanently removes this plant's production and downtime data within the selected date range. Preview the impact first, then confirm.
        error: Something went wrong. No data was deleted.
        errors:
          busy: Another job is writing this plant’s production data. Nothing was deleted — try again in a few minutes.
        from: From
        menu: Delete production data
        preview: Preview impact
        rows_header: Rows to delete
        table_header: Data
        title: 'Delete production data: {name}'
        to: To
        verified_blocked: This range overlaps verified downtime events, so the deletion is refused. Un-verify them or narrow the range.
